// Saisie décimale tolérante virgule/point, en `<input type="text" inputMode="decimal">` — jamais
// `type="number"` : au pavé numérique fr-FR d'une tablette, une valeur à virgule est rejetée par
// le navigateur et la saisie est perdue SANS message (piège documenté dans CLAUDE.md
// sipconfection-frontend pour tout `p-inputNumber`/cote de mesure de ce projet).

/** Ne garde que chiffres/virgule/point pendant la frappe, une seule virgule/point autorisé. */
export function nettoyerSaisieDecimale(brut) {
  const filtre = (brut || '').replace(/[^0-9,.]/g, '');
  const premierSeparateur = filtre.search(/[,.]/);
  if (premierSeparateur === -1) return filtre;
  const entier = filtre.slice(0, premierSeparateur).replace(/[,.]/g, '');
  const decimal = filtre.slice(premierSeparateur + 1).replace(/[,.]/g, '');
  return entier + ',' + decimal;
}

/** Vers un nombre pour l'API (`measuredValue`), `null` si vide — jamais NaN envoyé au serveur. */
export function versNombreOuNull(saisie) {
  if (saisie == null || saisie === '') return null;
  const n = Number(String(saisie).replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

/** D'un nombre serveur vers la forme affichée fr-FR (virgule), ex. 44.5 -> "44,5". */
export function versAffichage(valeur) {
  if (valeur == null) return '';
  return String(valeur).replace('.', ',');
}
